import { Config } from '@/types/config';
import passedTestConfigSets from '~test-config-sets';
import { getConfigProps } from '@/utils/get-config-props';

let testConfigSets = passedTestConfigSets.map(set => {
    return {
        ...set,
        title: 'test: ' + set.title,
    };
});

let customSets = [];

try {
    customSets = require('~custom-config-sets').default;
} catch (e) {
    customSets = [];
}

export function applyConfigSet (config: Config, id: string) {
    let applyConfig = testConfigSets.concat(customSets).find(item => item.title === id).config;
    let eApplyConfig = { ...applyConfig };

    if (eApplyConfig.apiUrl) {
        eApplyConfig.apiUrl = eApplyConfig.apiUrl.replace('{apiHost}', getConfigProps('', '').apiUrl);
    }
    if (eApplyConfig.staticUrl) {
        eApplyConfig.staticUrl = eApplyConfig.staticUrl.replace('{staticHost}', getConfigProps('', '').staticUrl);
    }

    config.update(eApplyConfig);
}
